import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const configuredApiUrl = process.env.REACT_APP_API_URL;
if (process.env.NODE_ENV === "production" && !configuredApiUrl) {
  throw new Error("REACT_APP_API_URL precisa ser configurada para a API HTTPS de produção.");
}

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // Mobile uploads on slower networks legitimately take longer than API JSON calls.
  timeout: 60000,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(async (response) => {
  if (response.status !== 202 || !response.data?.job_id) return response;
  const id = response.data.job_id;
  for (;;) {
    await new Promise(resolve => window.setTimeout(resolve, 3000));
    const { data: job } = await axiosInstance.get('clothing-items/image-jobs/' + id);
    if (job.status === 'ready') {
      window.dispatchEvent(new Event('wardrobe-updated'));
      return { ...response, status: job.http_status || 200, data: job.result };
    }
    if (job.status === 'failed') {
      throw Object.assign(new Error(job.error?.message || 'Não foi possível gerar a imagem.'), { response: {status: job.error?.status || 503, data: job.error} });
    }
  }
}, (error) => {
  const code = error.response?.data?.code;
  if (code === "AI_RATE_LIMITED") {
    const seconds = Number(error.response.data.retry_after_seconds || error.response.headers?.["retry-after"]) || 60;
    error.response.data.message = "Limite temporário de imagens atingido. Tente novamente em " + seconds + " segundos.";
  }
  if (process.env.NODE_ENV === "development") {
    const status = error.response?.status;
    const kind = error.code === "ECONNABORTED" ? "TIMEOUT" : status || (error.request ? "NETWORK_ERROR_OR_CORS" : "REQUEST_ERROR");
    console.error("API request failed", {
      kind,
      baseURL: error.config?.baseURL,
      pathname: error.config?.url,
      status,
      code: error.code,
      responseData: error.response?.data,
      timeout: error.config?.timeout,
    });
  }
  return Promise.reject(error);
});

export default axiosInstance;
